export default {
    lineOrderBy: 'position',
    lineSearch: '',
    lineSortOptions: {
        'position': 'Position: Low to High',
        '-position': 'Position: High to Low',
        'description': 'Description: A to Z',
        'price': 'Price: Low to High',
        '-price': 'Price: High to Low',
        'qtyShipped': 'Qty Shipped',
        '-qtyShipped': 'Qty Shipped: High to Low',
        'quantity': 'Qty: Low to High',
        '-quantity': 'Qty: High to Low',
        'productId': 'Item #: Low to High'
    },
    creditRequestFormTitle: "Credit Request Form",
    creditRequestStatuses: ["Open", "Submitted", "Approved", "Declined"],
    creditRequestDefaultStatus: "Open",
    requireComment: false,
    invoiceAgeLimit: 90

};